module.exports = __webpack_public_path__ + "static/media/Sustainability_banner.45942d06.jpg";